export enum RoleName {
  Presign = "presign",
  LabUser = "lab-user",
  ExternalUser = "external-user",
}
